import {useState} from 'react';

export const useImageViewer = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [viewerImages, setViewerImages] = useState<{fileName: string; url: string}[]>([]);

  const openImageViewer = (imageUrl: string, imageFileName: string, allImages: {fileName: string; url: string}[]) => {
    const imageIndex = allImages.findIndex((img) => img.url === imageUrl);
    setViewerImages(allImages);
    setCurrentImageIndex(imageIndex >= 0 ? imageIndex : 0);
    setIsViewerOpen(true);
  };

  const closeImageViewer = () => {
    setIsViewerOpen(false);
  };

  return {
    isViewerOpen,
    currentImageIndex,
    viewerImages,
    openImageViewer,
    closeImageViewer,
    setCurrentImageIndex,
  };
};
